import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faTimes } from '@fortawesome/free-solid-svg-icons';

import { getContent, getServerTime } from '../../util/responseUtil';
import { timeFromNow } from '../../util/date';
import { encodeHtml } from '../../util/htmlSpecialChar';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { ROLE_CATEGORY_CONSTANT } from '../../constants/roleCategoryConstant';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import IconIssueDescription from '../../assets/icons/IconIssueDescription';
import IconAddNoteGray from '../../assets/icons/IconAddNoteGray';
import IconSolutionGray from '../../assets/icons/IconSolutionGray';
import IconRelatedTicket from '../../assets/icons/IconRelatedTicket';
import { CheckPermissionComponent } from '../../util/permission';
import {
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE,
    TICKET_LIST_MEMBER_VIEW,
    TICKET_LIST_NEW_CSO_VIEW,
    TICKET_LIST_NEW_MANAGER_VIEW,
    TICKET_LIST_SOLUTION_VIEW
} from '../../constants/menuPermissionConstant';

class CollapseRelatedTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened: false,
            relatedTicket: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                count: 0
            },
            detailRelatedTicket: {},
            showRelatedTicketModal: false,
            serverTime: '',
            showLoadMore: true
        }
    }
    getDataRelatedTicketAllCSOInitate = () => {
        API_TICKET_LIST.getDataRelatedTicketAllCSOInitate(this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            count: getContent(res).count_data
                        },
                        serverTime: getServerTime(res)
                    })
                }
            })
    }

    getDataRelatedTicketAllCSO = () => {
        API_TICKET_LIST.getDataRelatedTicketAllCSO(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: getContent(res)
                        }
                    })
                }
            })
    }

    getDataRelatedTicketAllNonCSOInitate = () => {
        API_TICKET_LIST.getDataRelatedTicketAllNonCSOInitate(this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            count: getContent(res).count_data
                        },
                        serverTime: getServerTime(res)
                    })
                }
            })
    }

    getDataRelatedTicketAllNonCSO = () => {
        API_TICKET_LIST.getDataRelatedTicketAllNonCSO(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: getContent(res)
                        }
                    })
                }
            })
    }

    getDataRelatedTicketNewInitate = () => {
        API_TICKET_LIST.getDataRelatedTicketNewInitate(this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            count: getContent(res).count_data
                        },
                        serverTime: getServerTime(res)
                    })
                }
            })
    }

    getDataRelatedTicketNew = () => {
        API_TICKET_LIST.getDataRelatedTicketNew(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: getContent(res)
                        }
                    })
                }
            })
    }

    getDataRelatedTicketMemberInitate = () => {
        API_TICKET_LIST.getDataRelatedTicketMemberInitate(this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            count: getContent(res).count_data
                        },
                        serverTime: getServerTime(res)
                    })
                }
            })
    }

    getDataRelatedTicketMember = () => {
        API_TICKET_LIST.getDataRelatedTicketMember(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: getContent(res)
                        }
                    })
                }
            })
    }

    getDataRelatedTicketSolutionInitate = () => {
        API_TICKET_LIST.getDataRelatedTicketSolutionInitate(this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            count: getContent(res).count_data
                        },
                        serverTime: getServerTime(res)
                    })
                }
            })
    }

    getDataRelatedTicketSolution = () => {
        API_TICKET_LIST.getDataRelatedTicketSolution(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: getContent(res)
                        }
                    })
                }
            })
    }

    handleLoadMore = async () => {
        await this.setState({
            relatedTicket: {
                ...this.state.relatedTicket,
                page: this.state.relatedTicket.page + 1
            }
        })

        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                API_TICKET_LIST.getDataRelatedTicketAllCSO(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
                    .then(res => {
                        if (getContent(res).length === 0) {
                            return this.setState({
                                showLoadMore: false
                            })
                        }
                        let arr = this.state.relatedTicket.data.concat(getContent(res))
                        this.setState({
                            relatedTicket: {
                                ...this.state.relatedTicket,
                                data: arr
                            }
                        });
                    })
            } else {
                API_TICKET_LIST.getDataRelatedTicketAllNonCSO(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
                    .then(res => {
                        if (getContent(res).length === 0) {
                            return this.setState({
                                showLoadMore: false
                            })
                        }
                        let arr = this.state.relatedTicket.data.concat(getContent(res))
                        this.setState({
                            relatedTicket: {
                                ...this.state.relatedTicket,
                                data: arr
                            }
                        });
                    })
            }
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) {
            API_TICKET_LIST.getDataRelatedTicketNew(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
                .then(res => {
                    if (getContent(res).length === 0) {
                        return this.setState({
                            showLoadMore: false
                        })
                    }
                    let arr = this.state.relatedTicket.data.concat(getContent(res))
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: arr
                        }
                    });
                })
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)) {
            API_TICKET_LIST.getDataRelatedTicketMember(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
                .then(res => {
                    if (getContent(res).length === 0) {
                        return this.setState({
                            showLoadMore: false
                        })
                    }
                    let arr = this.state.relatedTicket.data.concat(getContent(res))
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: arr
                        }
                    });
                })
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            API_TICKET_LIST.getDataRelatedTicketSolution(this.state.relatedTicket.page, this.state.relatedTicket.limit, this.props.data.id, this.props.token)
                .then(res => {
                    if (getContent(res).length === 0) {
                        return this.setState({
                            showLoadMore: false
                        })
                    }
                    let arr = this.state.relatedTicket.data.concat(getContent(res))
                    this.setState({
                        relatedTicket: {
                            ...this.state.relatedTicket,
                            data: arr
                        }
                    });
                })
        }
    }

    handleOpenRelatedTicket = data => {
        this.setState({
            detailRelatedTicket: data,
            showRelatedTicketModal: true
        })
    }

    componentDidMount() {
        this._isMounted = true;

        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) {
            if (this.props.userDetail.level === ROLE_CATEGORY_CONSTANT.CSO) {
                this.getDataRelatedTicketAllCSOInitate()
                this.getDataRelatedTicketAllCSO()
            } else {
                this.getDataRelatedTicketAllNonCSOInitate()
                this.getDataRelatedTicketAllNonCSO()
            }
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)) {
            this.getDataRelatedTicketNewInitate()
            this.getDataRelatedTicketNew()
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)) {
            this.getDataRelatedTicketMemberInitate()
            this.getDataRelatedTicketMemberInitate()
        }
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)) {
            this.getDataRelatedTicketSolutionInitate()
            this.getDataRelatedTicketSolution()
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_VIEW, TICKET_LIST_ALL_VIEW_ASSIGNEE, TICKET_LIST_NEW_CSO_VIEW, TICKET_LIST_NEW_MANAGER_VIEW, TICKET_LIST_MEMBER_VIEW, TICKET_LIST_SOLUTION_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="text-sm border-b-2 border-gray-500 p-5">
                    <div className="flex items-center justify-between cursor-pointer select-none" id="btnrelatedticket" onClick={() => this.setState({ isOpened: !this.state.isOpened })}>
                        <p>Tiket Lain</p>
                        <FontAwesomeIcon icon={this.state.isOpened ? faChevronUp : faChevronDown} className="text-darkblue" />
                    </div>
                    <div className={!this.state.isOpened ? "hidden" : null}>
                        {
                            this.state.relatedTicket.data.length > 0
                                ? this.state.relatedTicket.data.map(data =>
                                    <div className="flex items-center mt-5 mb-5" key={data.id}>
                                        <div>
                                            <div className="flex justify-center items-center bg-blue-100 rounded-full w-10 h-10 mr-3">
                                                <IconRelatedTicket />
                                            </div>
                                        </div>
                                        <div>
                                            <p className="text-darkblue text-base font-bold cursor-pointer" id="btnrelatedticketdetail" onClick={() => this.handleOpenRelatedTicket(data)}>{data.issue_title}</p>
                                            <p className="text-xs">{moment.utc(data.created_at).format('DD/MM/YYYY HH:mm')}  ({timeFromNow(data.created_at, this.state.serverTime)})</p>
                                        </div>
                                    </div>
                                )
                                : <div className="mt-5">
                                    <p className="text-darkblue font-bold">Belum ada riwayat tiket</p>
                                </div>
                        }
                        {
                            this.state.relatedTicket.data.length > 0
                            && <div className={this.state.showLoadMore && this.state.relatedTicket.count > this.state.relatedTicket.limit ? "flex justify-center" : "hidden"}>
                                <button type="button" id="btnmore" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-1" onClick={() => this.handleLoadMore()}>Tampilkan Lebih Banyak</button>
                            </div>
                        }
                    </div>
                    <div className={this.state.showRelatedTicketModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/2 overflow-y-auto" style={{ height: '80%' }}>
                                <div className="header flex justify-between">
                                    <div></div>
                                    <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnrelatedticketclose" onClick={() => this.setState({ showRelatedTicketModal: false })} />
                                </div>
                                <div className="body bg-white rounded-2xl overflow-y-auto text-base">
                                    <div className="border-b-2 border-gray py-3">
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center">
                                                <div className={this.state.detailRelatedTicket.status + " flex justify-center items-center text-center text-white text-sm rounded-lg capitalize w-24 h-10 mr-3"}>
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.UNASSIGNED && "Unassigned"}
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.ASSIGNED && "Assigned"}
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && "In-Progress"}
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.ON_HOLD && "On-Hold"}
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.RESOLVED && "Resolved"}
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.CLOSED && "Closed"}
                                                    {this.state.detailRelatedTicket.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION && "Under Observation"}
                                                </div>
                                                <div className="text-gray-600">
                                                    <p className="mb-1">
                                                        <span>{this.state.detailRelatedTicket.ticket_no} | {this.state.detailRelatedTicket.percentage}% </span>
                                                    </p>
                                                    <p className="text-lg font-bold">{this.state.detailRelatedTicket.issue_title}</p>
                                                    <p className="text-sm capitalize my-1">{this.state.detailRelatedTicket.customer} | {this.state.detailRelatedTicket.tracker} | {moment.utc(this.state.detailRelatedTicket.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                                    <div className="flex text-sm my-1">
                                                        <p className="truncate mr-1" style={{ maxWidth: "180px" }} title={this.state.detailRelatedTicket.pic_name}>PIC : {this.state.detailRelatedTicket.pic_name}</p>
                                                        <p className="truncate" style={{ maxWidth: "180px" }} title={this.state.detailRelatedTicket.cs}> | CS : {this.state.detailRelatedTicket.cs}</p>
                                                    </div>
                                                    <p className="text-sm my-1">
                                                        Waktu dibuat {moment.utc(this.state.detailRelatedTicket.created_at).format('LL')}
                                                        {timeFromNow(this.state.detailRelatedTicket.open_at, this.state.serverTime) !== '' ? ' | Waktu respon ' + timeFromNow(this.state.detailRelatedTicket.open_at, this.state.serverTime) : ''}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex flex-col justify-center items-end text-gray-700">
                                                <div className="flex items-center capitalize">{this.state.detailRelatedTicket.priority} <div className={this.state.detailRelatedTicket.priority + " rounded-full h-5 w-5 ml-2"}></div></div>
                                                <select id="ddlrootcause" className="outline-none custom-select select-rtl my-1" disabled>
                                                    <option className="option-rtl">{this.state.detailRelatedTicket.root_cause_description}</option>
                                                </select>
                                                <select id="ddlcomplaint" className="outline-none custom-select select-rtl my-1" disabled>
                                                    <option className="option-rtl">{this.state.detailRelatedTicket.complaint}</option>
                                                </select>
                                                <select id="ddlcomplaintcategory" className="outline-none custom-select select-rtl my-1" disabled>
                                                    <option className="option-rtl">{this.state.detailRelatedTicket.complaint_category}</option>
                                                </select>
                                                <select id="ddlcomplaintsub" className="outline-none custom-select select-rtl my-1" disabled>
                                                    <option className="option-rtl">{this.state.detailRelatedTicket.complaint_sub}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className={this.state.detailRelatedTicket.solution !== '' ? "solution p-3 bg-blue-100 rounded-lg mt-3" : "hidden"}>
                                            <div className="flex">
                                                <div className="mt-1">
                                                    <IconSolutionGray />
                                                </div>
                                                <div className="ml-2">
                                                    <p className="font-bold text-gray-600">Solusi</p>
                                                </div>
                                            </div>
                                            <div className="text-sm ml-12 my-3" dangerouslySetInnerHTML={{ '__html': encodeHtml(this.state.detailRelatedTicket.solution) }} />
                                            <div className="text-gray-700 text-sm ml-12 my-3">
                                                <div><b>Versi Rilis</b> {this.state.detailRelatedTicket.release_version === '' ? ' -' : this.state.detailRelatedTicket.release_version}</div>
                                                <div>
                                                    <b>URL Link</b>
                                                    {
                                                        this.state.detailRelatedTicket.link_storage === ''
                                                            ? ' -'
                                                            : <a href={this.state.detailRelatedTicket.link_storage} target="_blank" rel="noreferrer" className="text-darkblue"
                                                            > {this.state.detailRelatedTicket.link_storage}</a>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="note p-3">
                                        <div className="flex">
                                            <div className="mt-1">
                                                <IconIssueDescription />
                                            </div>
                                            <div className="ml-2">
                                                <p className="font-bold text-gray-600">Deskripsi Keluhan</p>
                                                {/* <p className="text-xs">({moment.utc(this.state.detailRelatedTicket.created_at).format('ddd, DD MM YYYY')} di jam {moment.utc(this.state.detailRelatedTicket.created_at).format('HH:mm')})</p> */}
                                            </div>
                                        </div>
                                        <div className="text-sm ml-12" dangerouslySetInnerHTML={{ '__html': encodeHtml(this.state.detailRelatedTicket.issue_desc) }} />
                                    </div>
                                    <div className={this.state.detailRelatedTicket.note !== '' ? "note p-3" : "hidden"}>
                                        <div className="flex">
                                            <div className="mt-1">
                                                <IconAddNoteGray />
                                            </div>
                                            <div className="ml-2">
                                                <p className="font-bold text-gray-600">Note Tambahan</p>
                                                {/* <p className="text-xs">({moment.utc(this.state.detailRelatedTicket.created_at).format('ddd, DD MM YYYY')} di jam {moment.utc(this.state.detailRelatedTicket.created_at).format('HH:mm')})</p> */}
                                            </div>
                                        </div>
                                        <div className="text-sm ml-12" dangerouslySetInnerHTML={{ '__html': encodeHtml(this.state.detailRelatedTicket.note) }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(CollapseRelatedTicket);